export default __webpack_public_path__ + "static/media/kiosk-trans-greyscale-large-screen-highlight.588cd8e7.png";